import { useState, useEffect } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur-md shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollTo("company")}>
          <img
            src="https://public.readdy.ai/ai/img_res/8b0a0fe9-2c54-4ed5-8ae9-c59cc596a592.png"
            alt="FELIN SRL Logo"
            className="h-8 w-auto object-contain"
          />
          <span
            className={`font-bold text-lg tracking-tight transition-colors duration-300 ${
              scrolled ? "text-gray-900" : "text-white"
            }`}
          >
            FELIN SRL
          </span>
        </div>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {["company", "products", "features", "security", "contact"].map((section) => (
            <button
              key={section}
              onClick={() => scrollTo(section)}
              className={`text-sm font-medium capitalize tracking-wide transition-colors duration-300 cursor-pointer whitespace-nowrap ${
                scrolled ? "text-gray-600 hover:text-gray-900" : "text-white/80 hover:text-white"
              }`}
            >
              {section}
            </button>
          ))}
        </nav>

        {/* Mobile Hamburger */}
        <button
          className={`md:hidden text-xl cursor-pointer ${scrolled ? "text-gray-900" : "text-white"}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={menuOpen ? "ri-close-line" : "ri-menu-3-line"} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-4">
          {["company", "products", "features", "security", "contact"].map((section) => (
            <button
              key={section}
              onClick={() => scrollTo(section)}
              className="text-sm font-medium capitalize text-gray-700 hover:text-gray-900 text-left cursor-pointer whitespace-nowrap"
            >
              {section}
            </button>
          ))}
        </div>
      )}
    </header>
  );
}
